import { Injectable, Injector } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';
import { AuthService } from '../../auth.service';
import { DELETE_USER_TYPE, SET_USER_TYPE } from '../user';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginViewComponent } from '../../login/login-view.component';

@Injectable()
export class UserEffects {

  logoutUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DELETE_USER_TYPE),
      tap(action => {
        let authService = this.injector.get(AuthService);
        authService.navigateToLogoutRoute();
      })
    ),
    { dispatch: false }
  );

  loginUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SET_USER_TYPE),
      tap(action => {
        let authService = this.injector.get(AuthService);
        if (location.href.endsWith('/login') || location.href.endsWith('/cert-login')) {
          this.router.navigate(['mainView']);
        }
      })
    ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private injector: Injector,
    private router: Router,
  ) { }



}